<template>
<!--    <div class="container">-->
<!--        <ClcmsMenu @productsSelect="productsSelect"/>-->
<!--        <div>-->
<!--            <div class="title" data-aos="fade-up">AABB认证咨询培训服务</div>-->
<!--            <div class="content" v-for="item in content" data-aos="fade-up">-->
<!--                <div class="contentTitle">{{item.title}}</div>-->
<!--                <div class="text" v-html="item.text"></div>-->
<!--            </div>-->
<!--            <div class="pic" data-aos="zoom-in">-->
<!--                <img :src="require('@/assets/img/products/Aabb/contentPic.png')" alt="">-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</template>

<script>
import ClcmsMenu from "../../components/ClcmsMenu";
export default {
    name:'Aabb',
    components: {ClcmsMenu},
    data(){
      return {
          content:[
              {
                  title:'关于AABB',
                  text:'美国血液银行协会(AABB; American Association of Blood Banks )，是全世界最高水平的『血液银行及输血业务的标准指针』的最终认定组织单位，把输血医学及治疗的发展提升做为目的。为1947年所设立的国际的非营利团体。从以美利坚合众国为首的跨国性认证组织，全世界有80个以上国家的各国医院和血液银行与医学中心等约1800单位，有约8000名医疗工作者被审核许可参加，全部成员包括着医生和研究人员为基准参与的制定血液医学的最高标准单位。<br>' +
                      'AABB的最高标准认证范围包括:血液的保管、单位的处理、输血的单位，及造血干细胞移植的医疗单位和所有血液检验医学的检验单位等所有整合性检查认可，为血液的单位和医疗作业者所遵循把关来的基准制定、认可和推动作为主要的目标内容。'
              },
              {
                  title:'AABB制定的基准',
                  text:'AABB制定的基准，包含有相关联的法规，科学的根据，美国食品医药品局(FDA)及欧盟订定的医药品制造管理规则，按照(GMP)和质量及量测控制原则被慎重实行。2007年更加将这些的规则和国际标准化组织跟(ISO)定的国际质量管理控制规则(ISO9000系列)的条文合并纳入进行，作为实际上的全世界最慎重的国际基准。'
              },
              {
                  title:'基准的内容',
                  text:'基准的内容:从文件管理、设备管理等的营运管理，工作检验的内容等技术方面，工作人员的教育训练和物品进料经过质量及量测管理体制的所有全方位性面性。<br>' +
                      '另一方面又需定期性的内部监查稽核和二年由于一次的AABB监查员的外部监查稽核义务方能被认证许可，唯有真正的全方位的管理体制持续性地被维持作为重要的点被审查。'
              }
          ]
      }
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .title{
        width: 682px;
        height: 60px;
        font-family: SourceHanSansCN-Normal;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 2px;
        color: #ed1c24;
        margin: 0 17.5% 65px;
        padding-top: 100px;
        background: url("../../assets/img/products/Aabb/AabbTitle.png") 100% 100% no-repeat;
        text-align: center;
    }
    .content{
        margin-left: 110px;
        .contentTitle{
            background-color: #006efd;
            padding: 0 21px;
            height: 27px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 27px;
            letter-spacing: 2px;
            color: #ffffff;
            display: inline-block;
        }
        .text{
            width: 961px;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 1px;
            color: #000000;
            padding-left: 19px;
            margin-top: 24px;
            margin-bottom: 59px;
        }
    }
    .pic{
        margin-left: 10%;
        margin-bottom: 100px;
    }
</style>
